import { Box, Typography, Container, Paper, Button, Chip } from '@mui/material';
import { motion } from 'framer-motion';
import { CalendarToday, ArrowForward } from '@mui/icons-material';

const FeaturedArticle = () => {
  return (
    <Box sx={{ py: 15, background: '#0B0B0B' }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Paper
            sx={{
              background: 'linear-gradient(135deg, #1A1A1A, #0B0B0B)',
              border: '2px solid #C8A96B',
              borderRadius: 4,
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                gap: 4,
                p: { xs: 3, md: 6 },
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Chip
                  label="FEATURED ARTICLE"
                  sx={{
                    background: '#C8A96B',
                    color: '#000',
                    fontWeight: 600,
                    mb: 2,
                  }}
                />
                <Typography variant="h3" sx={{ mb: 2, fontWeight: 700 }}>
                  The No Gatekeepers Revolution
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                  <CalendarToday sx={{ fontSize: 16, color: '#C8A96B' }} />
                  <Typography variant="body2" sx={{ color: '#999' }}>
                    March 2025
                  </Typography>
                </Box>
                <Typography variant="body1" sx={{ color: '#ccc', mb: 3, lineHeight: 1.8 }}>
                  In this exclusive feature, John Asfar discusses why direct access to leadership
                  is transforming global business communication and creating unprecedented
                  opportunities for entrepreneurs and partners worldwide.
                </Typography>
                <Button
                  variant="outlined"
                  endIcon={<ArrowForward />}
                  sx={{
                    borderColor: '#C8A96B',
                    color: '#C8A96B',
                    '&:hover': {
                      background: '#C8A96B',
                      color: '#000',
                    },
                  }}
                >
                  Read Full Article
                </Button>
              </Box>
              <Box
                sx={{
                  flex: 1,
                  minHeight: { xs: '200px', md: 'auto' },
                  background: 'linear-gradient(135deg, #C8A96B20, #C8A96B05)',
                  borderRadius: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  src="/images/featured-article.jpg"
                  alt="Featured Article"
                  style={{
                    maxWidth: '100%',
                    borderRadius: 8,
                  }}
                />
              </Box>
            </Box>
          </Paper>
        </motion.div>
      </Container>
    </Box>
  );
};

export default FeaturedArticle;